import { useCallback } from "react"
import { KeyboardArrowUp } from "@mui/icons-material"
import useScrollTrigger from "@mui/material/useScrollTrigger"
import { Box, Fab, Zoom } from "@mui/material"

import { SCROLL_TO_TOP_BUTTON_BOTTOM } from "helpers/utils/constants"

const ScrollToTopButton = () => {
  const trigger = useScrollTrigger({
    threshold: 100,
    disableHysteresis: true,
  })

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }, [])

  return (
    <Zoom in={trigger}>
      <Box
        role="presentation"
        sx={{
          position: "fixed",
          bottom: SCROLL_TO_TOP_BUTTON_BOTTOM,
          right: 32,
          zIndex: 1000,
        }}
      >
        <Fab
          onClick={scrollToTop}
          color="primary"
          size="medium"
          aria-label="scroll-to-top"
          sx={{
            borderRadius: "5px",
          }}
        >
          <KeyboardArrowUp fontSize="medium" />
        </Fab>
      </Box>
    </Zoom>
  )
}

export default ScrollToTopButton
